<template>
 <div class="row mt-2">
    <div class="top-btn" title="Save changes to DB" style="cursor: pointer;">
      <icon-svg class="icon-menu" :height="25" :width="25" style="margin-inline: 8px"  icon="prime:save"
        @click="saveDstToUserArts()" />
      <span>Save</span>
    </div>

    <MDBTabs v-model="controlName">
      <MDBTabNav tabsClasses="mb-3">
        <MDBTabItem tabId="DstUserArts" href="DstUserArts">Dst user arts</MDBTabItem>
        <MDBTabItem tabId="SvgUserArts" href="SvgUserArts">Svg user arts</MDBTabItem>
      </MDBTabNav>

      <MDBTabContent>
        <MDBTabPane tabId="DstUserArts">
          <div class="col-md-10 offset-md-1">
            <table class="table responsive-table">
              <thead>
                <tr>
                  <th>User art Id</th>
                  <th>User visited ID</th>
                  <th>Preview</th>
                  <th>Is deleted</th>
                  <th>Art status</th>
                  <th>Edit Dst size</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(userArt, index) in store.getAllUserArts()" :key="index">
                  <td>{{ userArt.userUploadedArtID }}</td>
                  <td>{{ userArt.userVisitedID }}</td>
                  <td>
                    <div
                      style="
                        position: relative;
                        justify-content: center;
                        display: flex;
                      "
                    >
                      <img style="max-width: 85px; max-height: 85px;"
                          :src="`${store.baseURL}/${userArt.relativePath}_original.png`" />
                    </div>
                  </td>
                  <td>
                      <span>{{ userArt.isDeleted }}</span>
                  </td>
                  <td>{{ userArt.artStatus }}</td>
                  <td>
                      <!-- {{ art }} -->
                      <!-- {{ console.log('art = ', art) }}
                      {{ console.log('art.dstSizesJson = ', art.dstSizesJson) }}
                      {{  Object.values(JSON.parse(art.dstSizesJson).sizes).length == 0 ? 'No sizes' : 'Has sizes' }} -->
                    
                    <icon-svg
                    :style="{ color: store.getAllUserArtSizes(userArt.userUploadedArtID).length == 0 ? 'red' : 'black'}"
                      icon="line-md:edit"
                      :height="25"
                      :width="25"
                    style="cursor: pointer"
                      @click="(editArtPopup = true), editArt(userArt)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </MDBTabPane>
        <MDBTabPane tabId="SvgUserArts">
          <div class="col-md-10 offset-md-1">
            <table class="table responsive-table">
              <thead>
                <tr>
                  <th>User art Id</th>
                  <th>User visited ID</th>
                  <th>Preview</th>
                  <th>Is deleted</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(userArt, index) in store.getAllSvgUserArts()" :key="index">
                  <td>{{ userArt.userUploadedArtID }}</td>
                  <td>{{ userArt.userVisitedID }}</td>
                  <td>
                    <div
                      style="
                        position: relative;
                        justify-content: center;
                        display: flex;
                      "
                    >
                      <img style="max-width: 85px; max-height: 85px;"
                          :src="`${store.baseURL}/${userArt.relativePath}`" />
                    </div>
                  </td>
                  <td>
                      <span>{{ userArt.isDeleted }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </MDBTabPane>
      </MDBTabContent>
    </MDBTabs>
          
  </div>


         <MDBModal
    id="editArtPopup"
    tabindex="-1"
    labelledby="editArtPopupLabel"
    v-model="editArtPopup"
    centered
    scrollable
    ><MDBModalHeader>
      <MDBModalTitle id="editArtPopupLabel" :style="{ width: '100%' }">
        <div style="width: 100%; display: block">
          <span class="popup-title">
            <h4>
              {{ userArtToPopup.userUploadedArtID }}
            </h4>
          </span>
        </div>
      </MDBModalTitle>
    </MDBModalHeader>
    <MDBModalBody style="overflow-y: auto">
      <div>
        <form class="card col-md-8 offset-md-2">
          <div class="row p-2">
            <div class="col-md-4">
              <label class="form-text"> DST File </label>
              <input
                type="file"
                id="file"
                class="form-control custom-file-input"
                accept=".dst, .zip"
                multiple
                @change="uploadNewArtSize($event)"
              />
            </div>
            <div class="col-md-3">
              <label class="form-text"></label>
              <MDBInput label="Art Name" style="user-select: none;" disabled v-model="artName" />
            </div>
            <div class="col-md-3">
              <label class="form-text"></label>
              <MDBInput label="Size Name" v-model="newArtSizeName" />
            </div>
           
            <div class="col-md-2 p-3" title="Add new art" style="display: flex;  justify-content: center; gap: 20px;">
              <icon-svg
                icon="material-symbols:add-circle-outline"
                :height="35"
                :width="35"
                @click="addUserArtSizeToStore()"
              />
              <div v-if="isLoading == true" style="display: grid; justify-items: center;"><span>Sending...</span><MDBSpinner /></div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-6">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Size Name</th>
                  <th>Size of size</th>
                  <th>to delete</th> 
                  <!-- v-if="dstUserArt.sizes.length > 1" -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(size, index) in store.getAllUserArtSizes(
                    userArtToPopup.userUploadedArtID
                  )"
                  :key="index"
                >
                  <td>
                    <input
                      class="form-control"
                      type="text"
                      v-model="size.sizeName"
                    />
                  </td>
                  <td>
                    {{ size.dstfile.pixelWidth }}
                    X
                    {{ size.dstfile.pixelHeight }}
                  </td>
                  <td>
                    <icon-svg
                      icon="ic:baseline-delete"
                      :height="25"
                      :width="25"
                    style= "cursor: pointer;"
                      @click="removeUserArtSize(size.sizeID)"
                    />
                  </td>
                  <td></td>
                </tr>
                <tr v-if="store.getAllUserArtSizes(
                    userArtToPopup.userUploadedArtID
                  ).length == 0">
                  <td colspan="3" style="text-align: center">
                    No sizes available for this art.
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="showWaitMessage == true" style="color: red; font-size: 26px;">Wait!</div>
          </div>
          <div class="col-md-6 card" v-if="store.getAllUserArtSizes(
                    userArtToPopup.userUploadedArtID
                  ).length > 0">
            <div class="row card-img-top prevArt" style="height: 120px;">
              <DSTPreview 
              :dwidth="
                  (100.0 *
                    store.allUserArts.value[userArtToPopup.userUploadedArtID].dstSizesJson.sizes[store.getAllUserArtSizes(userArtToPopup.userUploadedArtID)[0].sizeID].dstfile.pixelWidth) /
                  store.allUserArts.value[userArtToPopup.userUploadedArtID].dstSizesJson.sizes[store.getAllUserArtSizes(userArtToPopup.userUploadedArtID)[0].sizeID].dstfile.pixelHeight
                "
                :dheight="100"
                :dstFile="
                  store.getAllUserArtSizes(
                    userArtToPopup.userUploadedArtID
                  )[0].dstfile
                "
                :layersColors="dstUserArt.defaultColors"
                left="10"
                top="10"
              
                  >
                </DSTPreview>
                <!-- :left="6 + getUserArtTopLeft(userArtToPopup.userUploadedArtID, store.getAllUserArtSizes(userArtToPopup.userUploadedArtID)[0].sizeID, 45, 45, 0).left" 
                :top="6 + getUserArtTopLeft(userArtToPopup.userUploadedArtID, store.getAllUserArtSizes(
                  userArtToPopup.userUploadedArtID
                )[0].sizeID, 45, 45, 0).top" -->
              <!-- <img style="max-height: 150px; object-fit: contain;" :src="`${store.baseURL}/${store.getAllUserArtSizes(
                    userArtToPopup.userUploadedArtID
                  )[0].dstfile.relativePath}_original.png`" /> -->
              <!-- <img style="max-height: 150px; object-fit: contain;" :src="`${store.baseURL}/${userArtToPopup.relativePath}_original.png`" /> -->
            </div>
            <div class="row card-body" style="justify-content: center;">
              <div
                class="divider dropdown"
                style="width: 200px;"
              >
                <div
                  v-for="(layer, index) in dstUserArt.defaultColors"
                  :key="index"
                >
                  <vue-select
                    :close-on-select="true"
                    :min="1"
                    :options="store.getAllColors()"
                    label-by="colorName"
                    searchable
                    :model-value="currentArtColors[index]"
                    @update:modelValue="(value) => {
                      if (value !== null && value !== undefined) { 
                      currentArtColors[index] = value
                      setColor(index, value);
                      }
                    }"
                  >
                    <template #label="{ selected }">
                      <template v-if="selected">
                        <div class="dd-color">
                            {{ selected }}
                          <span :style="{ backgroundColor: selected.color }">
                          </span>
                          {{ selected.colorName }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="dd-color">
                          <span
                            :style="{
                              backgroundColor:
                                store.allColors.value[dstUserArt.defaultColors[index]]
                                  .color,
                            }"
                          >
                          </span>

                          {{
                            store.allColors.value[dstUserArt.defaultColors[index]]
                              .colorName
                          }}
                        </div>
                      </template>
                    </template>
                    <template #dropdown-item="{ option }">
                      <div class="dd-color">
                        <span :style="{ backgroundColor: option.color }">
                        </span>
                        {{ option.colorName }}
                      </div>
                    </template>
                  </vue-select>
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MDBModalBody>
    <MDBModalFooter>
      <MDBBtn color="secondary" @click="editArtPopup = false">Close</MDBBtn>
    </MDBModalFooter>
  </MDBModal>
</template>

<script>
import { designerStore } from "@/stores/designerStore";
import {
  MDBInput,
  MDBBtn,
  MDBModal,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBSpinner,
  MDBTabs,
  MDBTabNav,
  MDBTabContent,
  MDBTabItem,
  MDBTabPane
} from "mdb-vue-ui-kit";
import VueSelect from "vue-next-select";
import DSTPreview from "@/components/DSTPreview.vue";
import { ref } from "vue";

export default {
  setup() {
    const store = designerStore();
    const editArtPopup = ref(false);
    const controlName = ref("DstUserArts");
    return {
      store,
      editArtPopup,
      controlName
    };
  },
  components: {
    DSTPreview,
    VueSelect,
    MDBInput,
    MDBBtn,
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBSpinner,
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane
  },
  data() {
    return {
        userArtToPopup: null,
        dstUserArt: null,
        currentArtColors: [],
        newContentDstFile: '',
        artName: '',
        newArtSizeName: '',
        showWaitMessage: false,

    };
  },

  methods: {
    async saveDstToUserArts() {
      this.showWaitMessage = true;
      await this.store.saveDstToUserArts();
      this.showWaitMessage = false;
    },
    async editArt(userArt) {
      this.userArtToPopup = userArt;
      this.dstUserArt = userArt.dstSizesJson;
      this.currentArtColors = [];
      this.artName = `userArt_#${userArt.userUploadedArtID}`;
        if(this.dstUserArt == null || this.dstUserArt == undefined) {
            this.dstUserArt = {
                artID: userArt.userUploadedArtID,
                artName: this.artName,
                sizes: {},
                defaultColors: [],
                isAvailable: true,
            };
            this.store.allUserArts.value[userArt.userUploadedArtID].dstSizesJson = this.dstUserArt;
            console.log(this.store.allUserArts.value[userArt.userUploadedArtID]);
            // this.store.newDstUserArt(
            //     userArt.userUploadedArtID,
            //     this.artName
            // );
        }
        if(this.dstUserArt.defaultColors != undefined) {
            for (var i = 0; i < Object.keys(this.dstUserArt.defaultColors).length; i++) {
                this.currentArtColors.push(this.store.getAllColorsDict()[this.dstUserArt.defaultColors[i]]);
            }
        }
      // this.popupCount++;
    },
    removeUserArtSize(sizeID) {
    //   if (Object.values(this.store.allUserArts.value[this.dstUserArt.userUploadedArtID].dstSizesJson.sizes).length > 1) {
        this.store.removeUserArtSize(this.userArtToPopup.userUploadedArtID, sizeID);
    //   } else {
    //     console.log("can not delete the last size");
    //   }
    },
    uploadNewArtSize(event) {
      const reader = new FileReader();
      reader.onload = () => {
        this.newContentDstFile = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    },
    async addUserArtSizeToStore() {      
      this.showWaitMessage = true;
      await this.store.addUserArtSizeToStore(
        this.userArtToPopup.userUploadedArtID,
        this.newContentDstFile,
        this.newArtSizeName
      );
      this.dstUserArt = this.store.allUserArts.value[this.userArtToPopup.userUploadedArtID].dstSizesJson;
      this.showWaitMessage = false;
    },
    setColor(index, value) {
      this.store.allUserArts.value[this.userArtToPopup.userUploadedArtID].dstSizesJson.defaultColors[index] =
        value.colorID;
    },
    getUserArtTopLeft(userArtId, artSizeId, height, width, arc) {
            var newArc = Math.abs(arc) > 90 ? Math.abs(arc) - 90 : Math.abs(arc);
            var artWidth = this.store.allUserArts.value[userArtId].dstSizesJson.sizes[artSizeId].dstfile.pixelWidth * (this.store.currentEditingProps.dpi / 254.0);
            var artHeight = this.store.allUserArts.value[userArtId].dstSizesJson.sizes[artSizeId].dstfile.pixelHeight * (this.store.currentEditingProps.dpi / 254.0);
            var artBoxWidth = (Math.cos((Math.PI / 180) * Math.abs(newArc)) * artWidth) + (Math.sin((Math.PI / 180) * Math.abs(newArc)) * artHeight);
            var artBoxHeight = (Math.cos((Math.PI / 180) * Math.abs(newArc)) * artHeight) + (Math.sin((Math.PI / 180) * Math.abs(newArc)) * artWidth);
            var top = 0;
            var left = 0;
            if (artBoxHeight > artBoxWidth) {
                top = 0;
                left = (width - (artBoxWidth * (height / artBoxHeight))) / 2;
            } else if (artBoxWidth > artBoxHeight) {
                top = (height - (artBoxHeight * (width / artBoxWidth))) / 2;
                left = 0;
            } else {
                top = 0;
                left = 0;
            }
            return {
                top: top,
                left: left
            };
        },
  }
};
</script>

<style scoped>
.dd-color > span {
  height: 20px;
  width: 20px;
  border-radius: 10px;
  display: inline-block;
}
</style>